import * as React from 'react';

import { trackRepresentativeTooltipOpen } from './tracking';
import { RepresentativeBadge } from '../../../../components/Commercial/RepresentativeBadge';
import { useOfferContext } from '../../../../context';
import { isRepresentative } from '../../../../utils/computedProps/commercial/isRepresentative';

export function RepresentativeBadgeContainer() {
  const { offer, position } = useOfferContext();

  const handleOpenTooltip = () => {
    trackRepresentativeTooltipOpen(offer.id, position);
  };

  if (!isRepresentative(offer)) {
    return null;
  }

  return <RepresentativeBadge onOpenTooltip={handleOpenTooltip} />;
}

RepresentativeBadgeContainer.displayName = 'RepresentativeBadgeContainer';
